import React, { useContext } from "react";
import UserContext from "../../context/UserContext";
import ChatContext from "../../context/ChatContext";
import { toast } from "react-toastify";
import { createInitials } from "../../utils/functions/createInitials";
import { IChatbotState } from "../../utils/interfaces/IChatbotState";
import { Box, Typography, Button } from "@mui/material";

interface IProps {
  closeTransferConfirmModal: () => void;
  closeTransferModal: () => void;
  userId: number;
  userName: string;
  chatRoomID: number;
  setUpdateChatRoomsFlag: any;
  chatRoomsArrayRef: any;
  closeMainModal: any;
}

const TransferChatConfirmModal: React.FC<IProps> = ({
  closeTransferConfirmModal,
  closeTransferModal,
  userId,
  userName,
  chatRoomID,
  setUpdateChatRoomsFlag,
  chatRoomsArrayRef,
  closeMainModal,
}) => {
  const { currentUser } = useContext(UserContext);
  const {
    setState,
    transferChat,
    getAssignedChatrooms,
    setTotalUnreadAssignedChats,
  } = useContext(ChatContext);

  const handleTransfer = async () => {
    const currentUserId = parseInt(currentUser.id)
    await transferChat(chatRoomID, currentUserId, userId).then((res: any) => {
      closeTransferConfirmModal()
      closeTransferModal()
      if (!!res && res.messageResponse === 'SUCCESS') {
        toast.success('Chat transferred successfully')
        getAssignedChatrooms().then((resAssigned: any) => {
          //   setIsLoading(false)
          if (!!resAssigned) {
            console.warn(resAssigned)
            const assignedChatrooms = resAssigned.assigned_chatrooms
            let assignedChatRoomsArray = []
            if (assignedChatrooms[0] !== null) {
              assignedChatRoomsArray = assignedChatrooms[0]
                .filter((chatRoom: any) => !!chatRoom)
                .map((chatRoom: any) => {
                  let initials

                  if (chatRoom.chatRoomMeta && chatRoom.chatRoomMeta.length > 0) {
                    const metaName = chatRoom.chatRoomMeta.find(
                      (metaData: any) => metaData.name === 'Name'
                    )
                    if (metaName) {
                      initials = createInitials(metaName.value)
                    } else if (chatRoom.id) {
                      initials = createInitials(chatRoom.id)
                    } else {
                      initials = createInitials('Unnamed')
                    }
                  } else if (chatRoom.id) {
                    initials = createInitials(chatRoom.id)
                  } else {
                    initials = createInitials('Unnamed')
                  }
                  return {
                    ...chatRoom,
                    initials
                  }
                })
                .sort((a: any, b: any) => {
                  // Sort by putting last chatRoomID in first
                  return parseInt(b.id) - parseInt(a.id)
                })
            }
            console.log(assignedChatRoomsArray)
            setTotalUnreadAssignedChats(assignedChatRoomsArray.length)
            chatRoomsArrayRef.current = assignedChatRoomsArray
            setUpdateChatRoomsFlag(true)
            console.log('Set to call useEffect to load assigned chatRooms')
          }
        })
        setState((prevState: IChatbotState) => ({
          ...prevState,
          conversation: []
        }))
      } else {
        toast.error('Unable to update status')
      }
    })
  }

  const handleCloseTransferConfirmModal = () => {
    closeTransferConfirmModal();
    closeMainModal();
  };
  return (
    <>
      <Typography variant="h6" fontWeight="bold">
        Are you sure you want to transfer the chat to {""}
        <Typography
          component="span"
          variant="h6"
          color="primary"
        >
          {userName}
        </Typography>
        ?
      </Typography>

      <Box display="flex" justifyContent="flex-end" mt={3}>
        <Button
          variant="outlined"
          onClick={handleCloseTransferConfirmModal}
          sx={{ mr: 2 }}
        >
          Cancel
        </Button>
        <Button variant="contained" onClick={handleTransfer}>
          Transfer
        </Button>
      </Box>
    </>
  );
};

export default TransferChatConfirmModal;
